import type { PieChartData } from '@/components/atoms/PieChart';
import { PieChart } from '@/components/atoms/PieChart';
import type { IWorkflowStatus } from '@/domains/workflows/api/workflow';
import { WorkflowChartDetails } from '@/pages/Workflows/components/organisms/WorkflowStatusChart/components/WorkflowChartDetails';

export type WorkflowChartData = {
  label: string;
} & PieChartData;

export type WorkflowStatusCount = Record<IWorkflowStatus, number>;

type Props = {
  data: WorkflowChartData[];
  size: number;
  innerRadius: number;
  outerRadius: number;
};

export const WorkflowChart = ({ data, size, innerRadius, outerRadius }: Props) => {
  return (
    <div className="align-center flex flex-row flex-nowrap gap-8">
      <div>
        <PieChart data={data} size={size} innerRadius={innerRadius} outerRadius={outerRadius} />
      </div>
      <div className="align-center flex flex-col justify-center">
        <WorkflowChartDetails data={data} />
      </div>
    </div>
  );
};
